<script setup lang="ts">
import { useI18n } from 'vue-i18n'

/**
 * How questions are answered, one click away under every question box (P4
 * §5.3, v3.5): a badge that opens the prompt-content contract, which names
 * the provider and the region and says what is and is never sent (P4 v1.5
 * change 7). Just its name, no line, icon or arrow beside it (Dao, DECISIONS.md
 * #36).
 */
const emit = defineEmits<{ howItWorks: [] }>()
const { t } = useI18n()
</script>

<template>
  <p class="disclosure" data-test="analyst-disclosure">
    <button type="button" class="disclosure__badge" data-test="analyst-how-it-works" @click="emit('howItWorks')">
      {{ t('analyst.disclosure.howItWorks') }}
    </button>
  </p>
</template>

<style scoped>
.disclosure {
  display: flex;
  margin: 0;
}

/* A small badge, as the kit draws them, that opens the contract. */
.disclosure__badge {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-xxs) var(--spacing-sm);
  border: var(--border-width-1) solid var(--line-subtle);
  border-radius: var(--radius-full);
  background: var(--surface-sunken);
  font: inherit;
  font-size: var(--font-size-body-3);
  line-height: var(--line-height-body-3);
  font-weight: var(--font-weight-medium);
  color: var(--fg-secondary);
  cursor: pointer;
}

.disclosure__badge:hover {
  background: var(--surface-hover);
  color: var(--fg-primary);
}

.disclosure__badge:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
</style>
